/*
    Implements Collapse list UI element

    items - array of struct {id, name, content, options}
        options - [maxWidth]
        content - string or function
    options - {collapseChangeCb}
 */

import {UIComponent} from "@/engine/UI/UIComponent.js";

export class UICollapseList extends UIComponent {

    constructor(options) {
        let defOptions = {
            id: "collapseList",
            collapseChangeCb: null,
            refreshItemCb: null,
            contextStorage: null,
            contextStorageKey: null,
            defaultChecked: true,
            items: []
        }

        super(Object.assign(defOptions, options), null);

        //this.container = null;
        this.listItems = [];
        this.view = document.createElement('ul')
        this.view.classList.add("m-d", "expand-list")

        for (let item of this.items) {
            let id = item.id
            let domListItem = document.createElement("li")
            domListItem.setAttribute("data-md-content", item.options && item.options.maxWidth ? item.options.maxWidth : "")

            domListItem.innerHTML = `
                <label name="tab" for="tab-${id}" tabindex="-1" class="tab_lab" role="tab">
                </label>
                <input type="checkbox" ${this.defaultChecked ? 'checked' : ''} class="tab" id="tab-${id}" tabindex="0" />
                <span class="collapse-list-item-header">${item.name}</span>
                <span class="collapse-list-open-close-icon"><i class="fa fa-caret-up"></i></span>
                
                <div class="content"></div>
            `
            this.view.appendChild(domListItem)
            domListItem.querySelector("input[type=checkbox]").
                addEventListener("change", function (e) {
                const ctx = this._context()
                // save context to storage
                this.saveContext(ctx)
                if (typeof this.collapseChangeCb === "function") {
                    this.collapseChangeCb(ctx)
                }
            }.bind(this))
            this.listItems.push(
                {   id: item.id,
                    element: domListItem,
                    contentElement: domListItem.querySelector('.content'),
                    headerElement: domListItem.querySelector('.collapse-list-item-header'),
                    content: item.content,
                    name: item.name,
                })
            this._updateItemContent(item.id)
        }
    }

    _getItemById(id) {
        for (let item of this.listItems) {
            if (item.id === id)
                return item
        }
        return null
    }

    setItemContent(id, content) {

    }

    _updateItemContent(id) {
        let el
        if (typeof id === 'object') {
            el = id
        } else {
            el = this._getItemById(id)
        }
        if (el === null)
            return

        let content = (typeof el.content === "function") ? el.content(el) : el.content
        if (typeof content === "string") {
            el.contentElement.innerHTML = content
        } else if (content instanceof UIComponent ) {
            el.contentElement.innerHTML = ""
            content.open(el.contentElement, this)
            el.headerElement.innerText = content.getTitle()
        } else if (content instanceof NodeList ) {
            el.contentElement.innerHTML = ""
            el.contentElement.append(...Array.from(content.values()))
        } else {
            el.contentElement.innerHTML = ""
            el.contentElement.append(content)
        }

        this._updateVisibility(el)

        if (typeof this.refreshItemCb === "function") {
            this.refreshItemCb(el.contentElement)
        }
    }

    // items configuration
    _context() {
        let context = []
        for (let item of this.listItems) {
            context.push({id: item.id, collapsed: !item.element.querySelector("input[type=checkbox]").checked})
        }
        return context
    }

    restoreContext(context) {
        if (! context) {
            return
        }
        for (let el of context) {
            let item = this._getItemById(el.id)
            if (!item)
                continue
            item.element.querySelector("input[type=checkbox]").checked = !el.collapsed
        }
    }

    refresh() {
        for (let item of this.listItems) {
            this._updateItemContent(item.id)
        }
    }

    _updateVisibility(item) {
        if (typeof item !== "object")
            item = this._getItemById(item)
        if (! item)
            return

        if (item.content === undefined ||
            item.content === "" ||
            item.contentElement.childElementCount === 0
        ) {
            this.hideItem(item)
        } else {
            this.showItem(item)
        }
    }

    hideItem(item) {
        if (typeof item !== "object")
            item = this._getItemById(item)
        if (item === null)
            return
        item.element.hidden = true
    }

    showItem(item) {
        if (typeof item !== "object")
            item = this._getItemById(item)
        if (item === null)
            return
        item.element.hidden = false
    }

    open(container) {
        // load context
        this.loadContext(this.restoreContext.bind(this))
        super.open(container)
    }

    childRefreshEvent(uic) {
        // updates title from UIC
        for (let item of this.listItems) {
            if (item.content === uic)
                item.headerElement.innerText = uic.getTitle()
            this._updateVisibility(item)
        }
    }
}
